import React, { ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';
import CustomerDetailCard from '../CustomerDetailCard/CustomerDetailCard';
import { RootState } from '../../../../../../../store';
import OtherMemberDetailCard from '../OtherMemberDetailCard/OtherMemberDetailCard';

const CustomerDetail = ({
  isLoading, form,
}: any): ReactElement | null => {
  const { isShowAdmissionForm: showAdmissionForm } = useSelector((state: RootState): any => state.newAdmission);
  const [isCertificateNoReq, setIsCertificateNoReq] = useState<boolean>(false);

  return showAdmissionForm ? <React.Fragment>
    <CustomerDetailCard
      isLoading={isLoading}
      form={form}
      setIsCertificateNoReq={setIsCertificateNoReq}
    />
    <OtherMemberDetailCard
      isLoading={isLoading}
      form={form}
      isCertificateNoReq={isCertificateNoReq}
    />
  </React.Fragment> : null;
};

export default CustomerDetail;
